<template>
  <div class="input-model-box">
    <el-input
      placeholder="请输入订单号"
      v-model="wholesaleOrderNo"
      @blur="tableDataChange"
      :disabled="column.disabled">
      <template slot="append">
        <div class="el-icon-more more-btn" @click="showTableDataList"></div>
      </template>
    </el-input>
    <el-dialog
      :title="column.label"
      :visible.sync="dialogVisible"
      @close="beforeClose"
      center
      :modal-append-to-body="false">
      <purchase-list-template ref="listTable" @rowClick="tableDataListCheck" :tableOptions="tableOptions"/>
    </el-dialog>
  </div>
</template>

<script>
import purchaseListTemplate from '@/components/template/purchaseListTemplate.vue';

export default {
  components: {purchaseListTemplate},
  props: ["column", "defaultValue"],
  data() {
    return {
      wholesaleOrderNo: "",
      checkList: [],
      dialogVisible: false,
      tableDataList: null,
      tableOptions: {
        url: this.column.url,
        height: "100%",
        isRowClick: true,
        columns: this.column.columns
      },
      btnClick: false
    };
  },
  watch: {
    defaultValue() {
      this.wholesaleOrderNo = this.defaultValue;
    }
  },
  methods: {
    initData() {
      this.wholesaleOrderNo = "";
      this.checkList = {};
    },
    showTableDataList() {
      if (this.column.disabled) return;
      this.btnClick = true;
      this.dialogVisible = true;
      this.getTableDataList();
    },
    tableDataChange() {
      if (this.btnClick) return;
      if (this.wholesaleOrderNo === "" || this.wholesaleOrderNo === null) return;
      this.dialogVisible = true;
      this.getTableDataList();
    },
    getTableDataList() {
      if (this.btnClick) this.wholesaleOrderNo = "";
      this.tableDataList = [];
      this.$nextTick(() => {
        this.$refs["listTable"].initData({
          storeId: this.column.params && this.column.params.storeId,
          warehouseId: this.column.params && this.column.params.warehouseId,
          wholesaleCustomerId: this.column.params && this.column.params.wholesaleCustomerId,
          supplierId: this.column.params && this.column.params.supplierId,
          orderNo: this.wholesaleOrderNo,
        });
      });
    },
    tableDataListCheck(row) {
      this.checkList = row;
      this.wholesaleOrderNo = row.orderNo;
      this.dialogVisible = false;
      this.$emit("valueChange", row, this.column);
    },
    beforeClose() {
      this.wholesaleOrderNo = this.checkList.orderNo;
      this.btnClick = false;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/business/orderDialog.vue